module.exports = __webpack_public_path__ + "static/img/empty-001.1577a04c.png";